
import React from 'react';
import { cn } from '@/lib/utils';

interface StatusBadgeProps {
  status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  let badgeClasses;
  
  switch (status.toLowerCase()) {
    case 'completed':
      badgeClasses = "bg-green-100 text-green-800";
      break;
    case 'pending':
      badgeClasses = "bg-yellow-100 text-yellow-800";
      break;
    case 'rejected':
      badgeClasses = "bg-red-100 text-red-800";
      break;
    case 'approved':
      badgeClasses = "bg-blue-100 text-blue-800";
      break;
    case 'shopify':
      badgeClasses = "bg-[#96bf48] bg-opacity-20 text-[#7A9E39]";
      break;
    case 'woocommerce':
      badgeClasses = "bg-purple-100 text-purple-800";
      break;
    case 'bigcommerce':
      badgeClasses = "bg-blue-100 text-blue-800";
      break;
    default:
      badgeClasses = "bg-gray-100 text-gray-800";
  }
  
  return (
    <span className={cn(
      "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
      badgeClasses
    )}>
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};

export default StatusBadge;
